import Link from "@components/Atoms/Link";
import { useRouter } from "@core/Api/useRouter";
import Url from "@core-ui/ApiServices/Types/Url";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { SIDEBAR_TRIGGER_ATTR } from "@core-ui/hooks/useSidebarFloating";
import t from "@ext/localization/locale/translate";
import { GlassToolbar, GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";
import { useSidebar } from "@ui-kit/Sidebar";
import { VIEWPORT_PADDING } from "../../../../ui-kit/lib/floating";

const sidebarTriggerProps = { [SIDEBAR_TRIGGER_ATTR]: true };

const useShowHomePageButton = () => {
	const { logo, cloudServiceUrl } = PageDataContextService.value.conf;
	const { isStatic, isStaticCli } = usePlatform();
	return (!(isStatic || isStaticCli) || !!cloudServiceUrl) && !logo.imageUrl;
};

const HomePageButton = () => {
	const router = useRouter();

	return (
		<GlassToolbarButton asChild focusable tooltipText={t("home")}>
			<Link dataQa="home-page-button" href={Url.fromRouter(router, { pathname: "/" })}>
				<GlassToolbarIcon icon="grip" />
			</Link>
		</GlassToolbarButton>
	);
};

export const CollapsedNavigationToolbar = () => {
	const { toggleSidebar } = useSidebar();
	const showHomePageButton = useShowHomePageButton();

	return (
		<GlassToolbar
			className="fixed"
			style={{
				left: VIEWPORT_PADDING,
				top: `calc(var(--catalog-titlebar-offset,0rem) + ${VIEWPORT_PADDING}px)`,
				zIndex: "var(--z-index-toolbar)",
			}}
			variant={showHomePageButton ? "default" : "single"}
		>
			{showHomePageButton && <HomePageButton />}
			<GlassToolbarButton
				onClick={toggleSidebar}
				tooltipSide="right"
				tooltipText={t("left-navigation.expand")}
				{...sidebarTriggerProps}
			>
				<GlassToolbarIcon icon="panel-left" />
			</GlassToolbarButton>
		</GlassToolbar>
	);
};

export default CollapsedNavigationToolbar;
